import { useReducedMotion } from 'framer-motion';
import * as React from 'react';
const CarouselContext = React.createContext({
    actions: {
        /* eslint-disable @typescript-eslint/no-empty-function */
        next: () => { },
        playPause: () => { },
        prev: () => { },
        /* eslint-enable @typescript-eslint/no-empty-function */
    },
    state: {
        autoplay: 0,
        disabled: false,
        isPaused: false,
        loop: false,
        max: 0,
        value: 0,
        /* eslint-disable @typescript-eslint/no-empty-function */
        onChange: () => { },
        /* eslint-enable @typescript-eslint/no-empty-function */
    },
});
export const useCarousel = () => React.useContext(CarouselContext);
const CarouselProvider = (props) => {
    const { autoplay, disabled, loop, max, value, onChange } = props;
    const shouldReduceMotion = useReducedMotion();
    const [isPaused, setIsPaused] = React.useState(shouldReduceMotion || autoplay === 0);
    const contextValue = {
        actions: {
            next,
            playPause,
            prev,
        },
        state: {
            autoplay,
            disabled,
            isPaused,
            loop,
            max,
            value,
            onChange,
        },
    };
    return (React.createElement(CarouselContext.Provider, { value: contextValue }, props.children(contextValue)));
    /** Set the autoplay state of the carousel. */
    function playPause(value) {
        setIsPaused(value);
    }
    /** Move to the previous slide, handles looping if enabled. */
    function prev() {
        if (loop && value === 0) {
            return onChange(max - 1);
        }
        onChange(Math.max(value - 1, 0));
    }
    /** Move to the next slide, handles looping if enabled. */
    function next() {
        if (loop && value === max - 1) {
            return onChange(0);
        }
        onChange(Math.min(value + 1, max - 1));
    }
};
export default CarouselProvider;
